export default __webpack_public_path__ + "static/media/1495.56d4c2b1.png";